import { FC, useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { Popups as PopupsPackage } from "@smile2impress/popups";
import { useRouter } from "next/router";
import { Popup } from "api/cms-website/cms-popups.types";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import { sendGTMEvent } from "services/AnaliticsService/sendGoogleAnalitic";

import popupsConfig from "./content";

type PathChangedHandler = (path: string) => void;

interface PopupsProps {
    // Overrides the build-time CMS popups JSON (used in preview mode).
    cmsPopups?: Popup[];
}

export const Popups: FC<PopupsProps> = ({ cmsPopups }) => {
    const { i18n } = useTranslation("global");
    const { locale } = useUTSLocaleContext();
    const router = useRouter();
    const [handler, setHandler] = useState<PathChangedHandler>(
        () => (_s: string) => {}
    );

    const popupsContent = popupsConfig(cmsPopups);

    // CMS-driven popups target pages by their localized URL (e.g. `/es/precios`),
    // so we match against the localized asPath rather than the route pattern.
    const getLocalizedPath = () =>
        `/${router.locale}${router.asPath.split(/[?#]/)[0]}`;

    useEffect(() => {
        handler(getLocalizedPath());
    }, [router.pathname, router.locale, router.asPath, locale]);

    return (
        <>
            <PopupsPackage
                popups={popupsContent}
                locale={locale}
                i18n={{ i18n }}
                subscribeToPathChanged={(cb: PathChangedHandler) => {
                    setHandler(() => cb);
                    return getLocalizedPath();
                }}
                sendGTMEvent={sendGTMEvent}
            />
        </>
    );
};
